<template>
  <div class="top_card">
    <!-- logo -->
    <img
      class="shaixuan1"
      src="~@/views/helpHandbook/images/logo_left_top.png"
      alt=""
    />
    <!-- 头部导航 -->
    <ul class="top_list">
      <li
        v-for="item in topList"
        :key="item.name"
        :class="{ home: item.name == curMenu }"
      >
        <a :href="item.toLink" target="_self">{{ item.label }}</a>
      </li>
      <template v-if="!isLogin">
        <li v-for="(item, index) in topList2" :key="index">
          <a :href="item.toLink" target="_blank">{{ item.label }}</a>
        </li>
      </template>
      <li v-else>
        <el-popover placement="top" trigger="click">
          <div class="user-info">
            <p>{{ userInfoData.lastName + userInfoData.firstName }}</p>
            <p>{{ userInfoData.email }}</p>
            <p class="look-profile" @click="handleToInfo">查看简档</p>
            <p class="look-profile" @click="handleLogout">退出</p>
          </div>
          <div slot="reference" class="name-profile">
            {{ userInfoData.lastName }}
          </div>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>
import mixin from "./mixin";
import { Popover } from "element-ui";
export default {
  mixins: [mixin],
  components: { "el-popover": Popover },
  data() {
    return {
      // 头部菜单
      topList: [
        { label: "主页", toLink: "/#/home", name: "/home" },
        { label: "社区", toLink: "/#/community", name: "/community" },
      ],
      topList2: [
        { label: "登录", toLink: "./login/#/community/login" },
        {
          label: "注册",
          toLink: "./login/#/community/register",
        },
      ],
    };
  },
  computed: {
    // 当前菜单
    curMenu() {
      return this.$route.fullPath;
    },
  },
  methods: {
    /**查看简档 */
    handleToInfo() {
      window.open("./login/#/profile", "_blank");
    },
    /**登出 */
    handleLogout() {
      this.$CCDK.CCToken.clearToken("communityToken");
      this.isLogin = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.top_card {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10%;
  .shaixuan1 {
    width: 183px;
    height: 44px;
  }
  .top_list {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    > li {
      margin: 0 12px;
      cursor: pointer;
    }
    .home {
      color: #006dcc;
    }
  }
}
// 查看简档
.user-info {
  line-height: 24px;
}
.look-profile {
  color: #3e7af7;
  cursor: pointer;
  padding-top: 8px;
}
.name-profile {
  border: 1px solid #dadada;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  text-transform: uppercase;
}
</style>